(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || window.themeMoney || '${{amount}}';
    function delimit(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function lockScroll(lock) { document.body.classList.toggle('is-locked', lock); }

  /* ---------- Drawers ---------- */
  function openDrawer(name) {
    var d = document.querySelector('[data-drawer="' + name + '"]');
    if (!d) return false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    return true;
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
    });
    lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    var modalOpener = e.target.closest('[data-modal-open]');
    if (modalOpener) {
      var m = document.getElementById(modalOpener.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lockScroll(true); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-modal-close]')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function refreshCart(open) {
    return fetch(window.themeRoutes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen || open) { current.classList.add('is-open'); current.setAttribute('aria-hidden', 'false'); lockScroll(true); }
        }
        return fetch(window.themeRoutes.cart + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch(window.themeRoutes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line-change'), 10), quantity: Math.max(0, parseInt(btn.getAttribute('data-qty'), 10)) })
    }).then(function () { return refreshCart(false); });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var code = (form.querySelector('input[name="discount"]').value || '').trim();
    if (!code) return;
    var note = form.parentElement.querySelector('[data-discount-note]');
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.themeRoutes.cart + '.js'), { credentials: 'same-origin' })
      .then(function () { return refreshCart(true); })
      .then(function () {
        var n = document.querySelector('#CartDrawer [data-discount-note]');
        if (n) { n.hidden = false; n.textContent = 'Code "' + code + '" will be applied at checkout if eligible.'; }
      });
  });

  /* ---------- Product ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var addText = section.querySelector('[data-add-text]');
    var addLabel = addText ? addText.textContent : 'Add to cart';
    var priceEl = section.querySelector('[data-price]');
    var stockEl = section.querySelector('[data-stock]');
    var errorEl = section.querySelector('[data-form-error]');
    var sticky = document.querySelector('[data-sticky-atc]');
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stickyAdd = sticky ? sticky.querySelector('[data-sticky-add]') : null;

    /* Gallery */
    var slides = Array.prototype.slice.call(section.querySelectorAll('.product__slide'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));
    function showMedia(id) {
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.getAttribute('data-media-id')) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v) { on ? v.play && v.play().catch(function () {}) : v.pause && v.pause(); }
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var on = String(t.getAttribute('data-thumb')) === String(id);
        t.classList.toggle('is-active', on);
        if (on && t.scrollIntoView) t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
      });
    }
    function step(dir) {
      var idx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var next = (idx + dir + slides.length) % slides.length;
      showMedia(slides[next].getAttribute('data-media-id'));
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var main = section.querySelector('.product__main-media');
    if (main && slides.length > 1) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        sx = null;
      });
    }

    /* Variants */
    var fieldsets = Array.prototype.slice.call(section.querySelectorAll('[data-option-index]'));
    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('[data-option-input]:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function priceHtml(v, badge) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<div class="price' + (onSale ? ' price--sale' : '') + (v.available ? '' : ' price--soldout') + '">';
      if (onSale) html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
      html += '<span class="price__current">' + formatMoney(v.price) + '</span>';
      if (badge && onSale) html += '<span class="badge badge--save">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>';
      if (!v.available) html += '<span class="badge badge--soldout">Sold out</span>';
      return html + '</div>';
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          input.closest('.option__value').classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function updateStock(v) {
      if (!stockEl) return;
      var low = parseInt(stockEl.getAttribute('data-low'), 10) || 0;
      var textEl = stockEl.querySelector('[data-stock-text]');
      stockEl.classList.remove('is-low', 'is-out');
      if (!v || !v.available) {
        stockEl.classList.add('is-out');
        textEl.textContent = stockEl.getAttribute('data-out-text');
      } else if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= low) {
        stockEl.classList.add('is-low');
        textEl.textContent = stockEl.getAttribute('data-low-text').replace('[count]', v.inventory_quantity);
      } else {
        textEl.textContent = stockEl.getAttribute('data-in-text');
      }
    }
    function onChange() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addText.textContent = 'Unavailable'; }
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = priceHtml(v, true);
      if (stickyPrice) stickyPrice.innerHTML = priceHtml(v, false);
      if (addBtn) { addBtn.disabled = !v.available; addText.textContent = v.available ? addLabel : 'Sold out'; }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      updateStock(v);
      if (v.featured_media_id) showMedia(v.featured_media_id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    section.querySelectorAll('[data-option-input]').forEach(function (input) { input.addEventListener('change', onChange); });
    if (fieldsets.length) markAvailability(selectedOptions());

    /* Quantity */
    var qtyInput = section.querySelector('[data-qty-input]');
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    }

    /* Add to cart (AJAX, falls back to normal submit) */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (addBtn) addBtn.classList.add('is-loading');
        fetch(window.themeRoutes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
            return refreshCart(true);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .then(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
      });
    }

    /* Sticky ATC */
    if (sticky && addBtn) {
      if (stickyAdd) stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          var show = !en.isIntersecting && below;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      io.observe(addBtn);
    }

    /* Delivery timeline (dates calculated from today) */
    var delivery = section.querySelector('[data-delivery]');
    if (delivery) {
      var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var addDays = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var g = function (k) { return parseInt(delivery.getAttribute(k), 10) || 0; };
      var range = function (a, b) { return a === b ? fmt(addDays(a)) : fmt(addDays(a)) + ' – ' + fmt(addDays(b)); };
      delivery.querySelector('[data-delivery-ordered]').textContent = fmt(new Date());
      delivery.querySelector('[data-delivery-ready]').textContent = range(g('data-ready-min'), g('data-ready-max'));
      delivery.querySelector('[data-delivery-delivered]').textContent = range(g('data-ship-min'), g('data-ship-max'));
    }
  }

  /* ---------- Misc ---------- */
  function initMisc() {
    var sort = document.querySelector('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var rec = document.getElementById('recover');
        var log = document.getElementById('login');
        if (!rec || !log) return;
        var showRec = rec.hidden;
        rec.hidden = !showRec;
        log.hidden = showRec;
      });
    });
    if (window.location.hash === '#recover') {
      var rec = document.getElementById('recover'), log = document.getElementById('login');
      if (rec && log) { rec.hidden = false; log.hidden = true; }
    }
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initMisc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
  });
})();
